import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CapitalizePipe} from './pipes/capitalize.pipe';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FilterPipe} from './pipes/filter.pipe';
import {
    NbActionsModule,
    NbAlertModule,
    NbButtonModule,
    NbCalendarKitModule,
    NbCardModule,
    NbCheckboxModule,
    NbContextMenuModule,
    NbDialogModule,
    NbFormFieldModule,
    NbIconModule,
    NbInputModule,
    NbLayoutModule,
    NbMenuModule,
    NbOptionModule,
    NbRadioModule,
    NbSelectModule,
    NbSpinnerModule,
    NbTooltipModule,
    NbUserModule
} from '@nebular/theme';
import {ContextMenuComponent} from './directives/context-menu/context-menu.component';
import {ContextMenuDirective} from '@shared/directives/context-menu/context-menu.directive';
import {SubmittedDirective} from '@shared/directives/submitted.directive';
import {AllCheckedPipe, IndeterminatePipe} from '@shared/pipes/indeterminate.pipe';
import {MenuPositionDirective} from './directives/context-menu/menu-position.directive';
import {NgSelectModule} from '@ng-select/ng-select';
import {NgOptionHighlightModule} from '@ng-select/ng-option-highlight';
import {TriangleDirective} from './directives/triangle.directive';
import {SortPipe} from './pipes/sort.pipe';
import {FileSizePipe} from '@shared/pipes/file-size.pipe';
import {SpinnerDirective} from 'app/@shared/directives/spinner/spinner.directive';
import {SpinnerComponent} from './directives/spinner/spinner.component';
import {FormControlErrorsDirective} from 'app/@shared/directives/form-control-errors/form-control-errors.directive';
import {FormControlErrorsComponent} from './directives/form-control-errors/form-control-errors.component';
import {PositionDirective} from '@shared/directives/position.directive';
import {HeaderComponent} from './components/header/header.component';
import {SideNavComponent} from './components/side-nav/side-nav.component';
import {FooterComponent} from './components/footer/footer.component';
import {MzRequiredDirective} from './directives/mz-required.directive';
import {MzPatternDirective} from './directives/mz-pattern.directive';
import {MzMinLengthDirective} from './directives/mz-min-length.directive';
import {MzPassEqualDirective} from './directives/mz-pass-equal.directive';
import {DialogBasicComponent} from './components/dialog/dialog-basic/dialog-basic.component';
import {MzMaxLengthDirective} from './directives/mz-max-length.directive';
import {MaxNumDirective} from '@shared/directives/max-num.directive';
import {PaginationComponent} from './components/pagination/pagination.component';
import {PageTableContainerComponent} from './page-table-container/page-table-container.component';
import {FocusDirective} from './directives/focus.directive';
import {TimerDirective} from './directives/timer.directive';
import {ImgUrlPipe} from './pipes/img-url.pipe';
import {NotificationsComponent} from './components/notifications/notifications.component';
import {ClickOutsideModule} from 'ng-click-outside';
import {MzDiffTimingDirective} from './directives/mz-diff-timing.directive';
import {MzDeclensionsDirective} from './directives/mz-declensions.directive';
import { MzMaskDirective } from './directives/mz-mask.directive';
import { ScrollQuestionsListDirective } from './directives/scroll-questions-list.directive';


const ENTRY_COMPONENTS = [
    ContextMenuComponent,
    SpinnerComponent,
];
const COMPONENTS = [
    ...ENTRY_COMPONENTS,
    PageTableContainerComponent,
    ContextMenuComponent,
    FormControlErrorsComponent,
    HeaderComponent,
    SideNavComponent,
    FooterComponent,
    DialogBasicComponent,
    PaginationComponent,
    NotificationsComponent
];
const MODULES = [
    CommonModule,
    FormsModule,
    NgSelectModule,
    NgOptionHighlightModule,
    RouterModule,
    ReactiveFormsModule,
    ClickOutsideModule

];
const NB_MODULES = [
    NbLayoutModule,
    NbContextMenuModule,
    NbMenuModule,
    NbCardModule,
    NbTooltipModule,
    NbFormFieldModule,
    NbIconModule,
    NbInputModule,
    NbDialogModule,
    NbSpinnerModule,
    NbCheckboxModule,
    NbButtonModule,
    NbCalendarKitModule,
    NbRadioModule,
    NbActionsModule,
    NbAlertModule,
    NbOptionModule,
    NbSelectModule,
    NbUserModule
];
const PIPES = [
    CapitalizePipe,
    FilterPipe,
    AllCheckedPipe,
    IndeterminatePipe,
    SortPipe,
    FileSizePipe,
    ImgUrlPipe
];
const DIRECTIVES = [
    ScrollQuestionsListDirective,
    MzDiffTimingDirective,
    SubmittedDirective,
    MzDeclensionsDirective,
    ContextMenuDirective,
    MenuPositionDirective,
    MzMaskDirective,
    TriangleDirective,
    SpinnerDirective,
    FormControlErrorsDirective,
    PositionDirective,
    MzRequiredDirective,
    MzPatternDirective,
    MzMinLengthDirective,
    MzPassEqualDirective,
    MzMaxLengthDirective,
    MaxNumDirective,
    FocusDirective,
    TimerDirective
];


@NgModule({
    imports: [...MODULES, ...NB_MODULES],
    exports: [...MODULES, ...NB_MODULES, ...PIPES, ...COMPONENTS, ...DIRECTIVES],
    entryComponents: [...ENTRY_COMPONENTS],
    declarations: [...COMPONENTS, ...PIPES, ...DIRECTIVES],
})

export class SharedModule {

}
